import {ProjectSummary} from 'constants/SourceConstants';
import {User} from 'constants/UserConstants';
import * as net from 'util/Net';
import * as TaskRunner from 'util/TaskRunner';

import {OrganizationPermission, Team} from './OrganizationConstants';

export function get(teamId: string): JQueryPromise<Team> {
  return net.getJSON(`/1/api/teams/${teamId}`);
}

export interface CreateTeamData {
  organizationId: string;
  name: string;
  description?: string;
  isSchemaAdmin?: boolean;
}

export function create(data: CreateTeamData): JQueryPromise<Team> {
  return net.postJSON({
    url: '/1/api/teams/',
    data,
  });
}

export function getMembers(
  teamId: string,
  {getMemberInfo = true}: {getMemberInfo: boolean}
): JQueryPromise<{members: Array<User>; permissions: Array<OrganizationPermission>}> {
  return net.getJSON(`/1/api/teams/${teamId}/members`, {getMemberInfo});
}

export function updateMemberRole(teamId: string, userId: string, data: {role: number}): JQueryPromise<{}> {
  return net.patchJSON({
    url: `/1/api/teams/${teamId}/members/${userId}`,
    data,
  });
}

export function removeMember(teamId: string, userId: string): JQueryPromise<{}> {
  return net.delete_({
    url: `/1/api/teams/${teamId}/members/${userId}`,
  });
}

export function addMember(teamId: string, userId: string): Promise<void> {
  return net.postPromise({
    url: `/1/api/teams/${teamId}/members/${userId}`,
  });
}

export interface UpdateTeamData {
  name: string;
  description: string;
  isSchemaAdmin?: boolean;
}

export function update(teamId: string, data: UpdateTeamData): Promise<Team> {
  return TaskRunner.patchJSONPromise({
    url: `/1/api/teams/${teamId}`,
    data,
  });
}

export function fetchProjects(teamId: string): Promise<{projects: Array<ProjectSummary>}> {
  return net.getJSONPromise(`/1/api/teams/${teamId}/projects`);
}

export function teamURL(teamId: string): string {
  return `/teams/${teamId}`;
}

export function updateTeamAvatar(teamId: string, avatarFile: File): Promise<Team> {
  return net.postFileAsFormDataPromise({
    url: `/1/api/teams/${teamId}/actions/update-avatar`,
    key: 'avatar',
    file: avatarFile,
  });
}

export function removeTeamAvatar(teamId: string): Promise<Team> {
  return net.deletePromise({
    url: `/1/api/teams/${teamId}/actions/remove-avatar`,
  });
}

export function deleteTeam(teamId: string): Promise<{}> {
  return net.deletePromise({url: `/1/api/teams/${teamId}`});
}
